import { PlaceholderOptions } from "pptxgenjs"
import * as Constants from "./constants"
import { toInches } from "../utils"

export enum Placeholder {
	Body = "page-body",
	Subtitle = "page-subtitle",
	Title = "page-title"
}

export function getPlaceholderBodyOptions(): PlaceholderOptions {
	return {
		align: "center",
		color: "000000",
		fontFace: Constants.SUB_FONT_FACE,
		fontSize: 16,
		h: Constants.bodyBottom - Constants.bodyTop,
		name: Placeholder.Body,
		type: "body",
		valign: "top",
		w: "60%",
		x: "40%",
		y: Constants.layout.middle,
	}
}

export function getPlaceholderSubtitleOptions(
	placeholderTitleOptions: PlaceholderOptions
): PlaceholderOptions {
	const h = toInches(1.4)
	const y = (placeholderTitleOptions.y as number)
	+ (placeholderTitleOptions.h as number)
	+ Constants.gap

	return {
		...Constants.defaultSubtitleOptions,
		h,
		name: Placeholder.Subtitle,
		type: "body",
		w: Constants.innerWidth,
		x: Constants.margins.left,
		y,
	}
}

export function getPlaceholderTitleOptions(): PlaceholderOptions {
	return {
		...Constants.defaultTitleOptions,
		h: Constants.titleH,
		name: Placeholder.Title,
		type: "title",
		w: Constants.titleW,
		x: Constants.margins.left,
		y: Constants.titleTop
	}
}

export function getPlaceholderTitlePartOptions(): PlaceholderOptions {
	return {
		align: "center",
		color: Constants.DEFAULT_TEXT_COLOR,
		fontFace: Constants.SUB_FONT_FACE,
		fontSize: 34,
		valign: "Bottom",
		h: Constants.titleH,
		name: Placeholder.Title,
		type: "title",
		w: "60%",
		x: "40%",
		y: "40%"
	}
}


export function getPlaceholderChartBodyOptions(): PlaceholderOptions {
	return {
		align: "left",
		color: Constants.DEFAULT_TEXT_COLOR,
		fontFace: Constants.SUB_FONT_FACE,
		fontSize: 20,
		h: Constants.bodyBottom - Constants.bodyTop,
		name: Placeholder.Body,
		type: "body",
		valign: "top",
		w: Constants.bodyW,
		x: Constants.margins.left,
		y: Constants.bodyTop,
	}
}


// WEBPACK FOOTER //
// ./src/component/management-report/generator/pptx-configuration/placeholders.ts